export const RESET_COPY = {
    title: 'Recupera la password',
    subtitle: 'Ti mandiamo un codice all’email del tuo account.',
    intro: 'Inserisci l’email con cui entri: ti mandiamo un codice per scegliere una nuova password.',
    doneTitle: 'Password aggiornata',
    done: 'Da ora entri con la nuova password. Le altre sessioni sono state chiuse per sicurezza.',
} as const;
